module.exports = __webpack_public_path__ + "static/media/settings.ffbea7f8.svg";